"use client";
import React, { useRef, useState } from "react";
import "./style.css";

const Tile = ({ tile, onChange, preview }) => {
    const { grow, media, mediaType, caption, link } = tile;
    const fileInputRef = useRef();
    const [openMenu, setOpenMenu] = useState(false);

    return (
        <div
            className={`Tile relative border-2 border-purple-500/70 ${
                !preview ? "p-1" : ""
            } hover:border-blue-500 overflow-hidden flex flex-col justify-center text-center`}
            style={{ flexGrow: grow }}
        >
            {mediaType === "image" ? (
                <img
                    lazyload='true'
                    className='absolute h-full w-full'
                    src={media}
                    alt={caption}
                    style={{ objectFit: "cover" }}
                />
            ) : (
                <video className='' src={media}></video>
            )}
            <div
                style={{ zIndex: 2 }}
                className='flex flex-col gap-2 relative text-white font-thin  text-lg top-0 justify-center'
            >
                <input
                    style={{ display: "none" }}
                    type='file'
                    ref={fileInputRef}
                    accept='image/* video/*'
                    onChange={async (e) => {
                        let file = e.target.files?.[0];
                        if (!file) return;
                        onChange({
                            ...tile,
                            media: URL.createObjectURL(file),
                            file,
                            mediaType: file.type.includes("image")
                                ? "image"
                                : "video",
                        });
                        e.target.value = null;
                    }}
                />
                <input
                    className='!bg-blue-900/70 text-center py-1 px-2'
                    type='text'
                    placeholder='متن'
                    value={caption || ""}
                    onChange={(e) => {
                        onChange({
                            ...(tile || {}),
                            caption: e.target.value,
                        });
                    }}
                />
                <textarea
                    className='!bg-blue-900/70 py-1 px-2 text-center'
                    value={link || ""}
                    placeholder='لینک'
                    onChange={(e) => {
                        onChange({
                            ...(tile || {}),
                            link: e.target.value,
                        });
                    }}
                ></textarea>
            </div>
            <div
                className='INDICATE absolute flex flex-row top-0  left-0  w-fit max-h-full  overflow-y-auto'
                style={{ zIndex: 2 }}
            >
                {openMenu && (
                    <div className='bg-purple-500/70 rounded-xl flex flex-row'>
                        <div className={`flex flex-col items-center`}>
                            <div
                                className=' btn btn-circle text-white ri-add-line  text-lg btn-sm m-2'
                                onClick={(e) => {
                                    onChange("increase");
                                }}
                            ></div>
                            <div className='bg-slate-700 text-black text-center items-center flex p-1 rounded-full h-fit w-fit justify-center'>
                                {(
                                    parseFloat(
                                        parseInt(parseFloat(grow) * 10)
                                    ) / 10
                                ).toString()}
                            </div>
                            <div
                                className=' btn btn-circle text-white ri-subtract-line  text-lg btn-sm m-2'
                                onClick={(e) => {
                                    onChange("decrease");
                                }}
                            ></div>
                        </div>
                        <div className={`flex flex-col`}>
                            <div
                                className=' btn btn-circle  text-blue-500 ri-file-image-line text-lg btn-sm m-1'
                                onClick={(e) => {
                                    fileInputRef.current.click();
                                }}
                            ></div>
                            <div
                                className=' btn btn-circle  ri-delete-bin-line text-red-500 text-lg btn-sm m-1'
                                onClick={(e) => {
                                    onChange(null);
                                }}
                            ></div>
                            <div
                                className=' btn btn-circle text-white ri-arrow-right-line  text-lg btn-sm m-2'
                                onClick={(e) => {
                                    onChange("backward");
                                }}
                            ></div>
                            <div
                                className=' btn btn-circle text-white ri-arrow-left-line  text-lg btn-sm m-2'
                                onClick={(e) => {
                                    onChange("forward");
                                }}
                            ></div>
                        </div>
                    </div>
                )}
                <div
                    onClick={(e) => setOpenMenu(!openMenu)}
                    className={`btn m-1 btn-${
                        openMenu ? "error btn-sm" : "accent btn-md"
                    } btn-circle`}
                >
                    <i
                        className={`ri-${
                            openMenu ? "close" : "menu"
                        }-line text-white`}
                    ></i>
                </div>
            </div>
        </div>
    );
};

export default Tile;
